const TAG_COLOR_OPTIONS = [
  { bgColor: '#FBECCC', name: 'Yellow' },
  { bgColor: '#DFECDD', name: 'Green' },
  { bgColor: '#F2E1E9', name: 'Pink' },
  { bgColor: '#D6E5EE', name: 'Blue' },
  { bgColor: '#FBD3CB', name: 'Coral' },
  { bgColor: '#FBEDD1', name: 'Orange' },
  { bgColor: '#F6DFCC', name: 'Peach' },
  { bgColor: '#E6DFED', name: 'Purple' }
];

export default TAG_COLOR_OPTIONS;
